import { CarrierId, GroupId } from '../../types/api/primaryKeys/PrimaryKey';
import ApiRequest from '../../utils/ApiRequest';

/** Fetches a group image and returns its blob contents. */
export async function getGroupImageBlob(groupId: GroupId, fileName: string) {
    const blob = await ApiRequest.downloadBlob(`groups/${groupId}/images/${fileName}`);
    return blob;
}


/** Fetches a carrier image and returns its blob contents. */
export async function getCarrierImageBlob(carrierId: CarrierId, carrierLogoFileName: string) {
    const blob = await ApiRequest.downloadBlob(`carriers/${carrierId}/images/${carrierLogoFileName}`);
    return blob;
}